<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDataStore } from '@/store/data'
import { menuController } from '@ionic/vue'
import { removeLocalData } from '@/utils/localdata';
import KiwishModal from '@/views/components/KiwishModal.vue';

const router = useRouter()
const dataStore = useDataStore()
const isHybrid = dataStore.isHybrid
const VUE_ASSETS_URL = process.env.VUE_APP_ASSETS_URL
const APP_NAME = process.env.VUE_APP_NAME
const logoutConfirmVisible = ref(false)

// Cierra menú y navega a ruta
const goTo = async (path) => {
  await menuController.close()
  router.push(path)
}

const showLogoutConfirm = () => {
  logoutConfirmVisible.value = true
}

const cancelLogout = () => {
  logoutConfirmVisible.value = false
}

const toLogOut = async () => {
  logoutConfirmVisible.value = false
  await menuController.close()

  // Limpiar datos de autenticación
  await removeLocalData('authToken');
  await removeLocalData('userData');

  // Limpiar estado del store
  dataStore.fans = [];
  dataStore.secrets = [];
  dataStore.matchs = [];

  // Usar window.location para forzar recarga limpia y evitar conflictos con Vue
  window.location.href = '/auth/login';
};
</script>

<template>
  <ion-menu
    v-if="!isHybrid"
    side="start"
    content-id="main-content"
    type="overlay"
    class="kiwish-menu"
    menu-id="main"
  >
    <ion-header>
      <ion-toolbar class="menu-header">
        <div class="logo">
          <img
            :src="VUE_ASSETS_URL + 'logokw.png'"
            :alt="APP_NAME"
            class="logo-img"
          />
        </div>
        <ion-buttons slot="end">
          <ion-button fill="clear" class="close-btn" @click="menuController.close()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="menu-content">
      <ion-list lines="none" class="menu-list">

        <ion-item button detail="false" @click="goTo('/app/secrets/new')" class="menu-btn">
          <ion-label>{{ $t('tabs.secrets.new') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="goTo('/app/fans')" class="menu-btn">
          <ion-label>{{ $t('tabs.fans') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="goTo('/app/secrets')" class="menu-btn">
          <ion-label>{{ $t('tabs.secrets') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="goTo('/app/matchs')" class="menu-btn">
          <ion-label>{{ $t('tabs.matchs') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="goTo('/app/account')" class="menu-btn">
          <ion-label>{{ $t('tabs.account') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="goTo('/app/help')" class="menu-btn">
          <ion-label>{{ $t('help.title') }}</ion-label>
        </ion-item>

        <ion-item button detail="false" @click="showLogoutConfirm()" class="menu-btn">
          <ion-label>{{ $t('logout') }}</ion-label>
        </ion-item>
      </ion-list>

      <!-- Modal de confirmación de logout -->
      <KiwishModal
        :is-open="logoutConfirmVisible"
        max-width="350px"
        @close="cancelLogout"
      >
        <div class="logout-modal-inner">
          <div class="ion-text-center">
            <ion-icon icon="log-out-outline" class="logout-icon"></ion-icon>
          </div>
          <div class="ion-text-center mt-4">
            <ion-text class="logout-title">{{ $t('logout.confirm.title') }}</ion-text>
          </div>
          <div class="ion-text-center mt-3">
            <ion-text class="logout-message">{{ $t('logout.confirm.message') }}</ion-text>
          </div>
          <div class="logout-buttons">
            <ion-button class="button-outline-pink" expand="block" @click="cancelLogout">
              {{ $t('cancel') }}
            </ion-button>
            <ion-button class="button-pink" expand="block" @click="toLogOut()">
              {{ $t('logout') }}
            </ion-button>
          </div>
        </div>
      </KiwishModal>
    </ion-content>

  </ion-menu>
</template>

<style scoped>

.kiwish-menu {
  --width: 100vw;
  --background: linear-gradient(to bottom, var(--ion-color-header), var(--ion-color-footer));
  color: #fff;
}

ion-list {
  --ion-item-background: transparent;
  --background: transparent;
  padding: 1rem;
}

.menu-header {
  padding: 1rem 1.5rem;
  --background: transparent !important;
  background: transparent !important;
}

.menu-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #fff;
}

.close-btn ion-icon {
  font-size: 1.8rem;
  color: #fff;
}

.menu-content {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.menu-list {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
  width: 100%;
  max-width: 340px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.menu-list ion-item {
  border-radius: 12px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
}
.menu-list ion-item:last-child {
  margin-bottom: 0;
}

.menu-list ion-item:hover {
  --background: transparent;
  -webkit-transform: translateX(4px);
  transform: translateX(4px);
}

.logo {
  text-align: center;
  margin-bottom: 0.5rem;
}
.logo-img {
  max-width: 130px;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.menu-btn {
  --ion-item-background: #F8E9BF !important;
  --background: #F8E9BF !important;
  background: #F8E9BF !important;
  background-color: #F8E9BF !important;
  --color: #333 !important;
  border-radius: 18px;
  font-size: 1.2rem;
  font-weight: 600;
  height: 3rem;
  -webkit-transition: transform 0.15s ease, box-shadow 0.15s ease;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.menu-btn:hover {
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
  -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.menu-btn ion-label {
  padding: 0;
  text-align: left;
  padding-left: 1rem;
  --color: #141B23;
  font-size: 1.1rem;
}

@media (max-height: 600px) {
  .menu-content {
    justify-content: flex-start;
    padding-top: 2rem;
  }
}

/* Logout confirmation modal inner content */
.logout-modal-inner {
  text-align: center;
  padding: 10px 0;
}

.logout-icon {
  font-size: 4rem;
  color: #FF5287;
}

.logout-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #5A695B;
}

.logout-message {
  font-size: 1rem;
  color: #5A695B;
}

.logout-buttons {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  margin-top: 1.5rem;
}

.logout-buttons ion-button {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  margin-right: 10px;
}

.logout-buttons ion-button:last-child {
  margin-right: 0;
}

.button-pink {
  --background: #FF5287 !important;
  --background-activated: #e94a78 !important;
  --background-hover: #ff6b9a !important;
  --color: #FFFFFF !important;
}

.button-outline-pink {
  --background: #fff;
  --background-activated: rgba(255, 82, 135, 0.1) !important;
  --background-hover: rgba(255, 82, 135, 0.05) !important;
  --border-color: #FF5287 !important;
  --border-width: 2px !important;
  --border-style: solid !important;
  --color: #FF5287 !important;
}
</style>